import React, { Fragment, useState } from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { makeStyles } from '@material-ui/core/styles';

import {
  Switch,
  Typography,
  Divider,
  Dialog,
  DialogContent,
  DialogTitle,
  Box,
  Button,
  Grid,
  colors,
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    position: 'relative',
    overflow: 'auto',
  },
  avatar: {
    backgroundColor: colors.grey[200],
    width: "100%",
    height: "100%",
    maxWidth: 350,
    maxHeight: 200
  },
  fieldset: {
    margin: 15
  }
}));

const Panel = ({ item, closeEdition, updateValues, open, hardwares }) => {

  const classes = useStyles();

  return (
    <Fragment>

      <Dialog aria-modal="true" open={open} aria-labelledby="form-dialog-title" maxWidth="md"  >
        <DialogTitle id="form-dialog-title">
          <Typography
            color="textPrimary"
            variant="h4">
            Painel de Instrumentação
          </Typography>
        </DialogTitle>
        <Divider />
        <DialogContent>

          <Box
            display="flex"
            flexDirection="column"
            height="100%"
            justifyContent="center"
          >
            <Formik
              initialValues={item}
              validationSchema={
                Yup.object().shape({
                })
              }
              onSubmit={(values, formik) => {
                updateValues(values);
                formik.setSubmitting(false);
              }}
            >
              {({
                errors,
                handleBlur,
                handleChange,
                handleSubmit,
                isSubmitting,
                touched,
                values
              }) => (
                <form onSubmit={handleSubmit}>
                  <Grid
                    container
                    spacing={2}
                  >

                    <Grid item ><br></br></Grid>
                  </Grid>
                  <Box my={1}></Box>
                  <Divider />

                  <Box my={1}>
                    <Grid container
                      direction="row"
                      justify="flex-end"
                      alignItems="baseline"
                      spacing={1}  >
                      <Grid item >
                        <Button
                          color="secondary"
                          disabled={isSubmitting}
                          size="small"
                          type="submit"
                          variant="contained">
                          Salvar
                        </Button>
                      </Grid>
                      <Grid item >
                        <Button
                          color="secondary"
                          disabled={isSubmitting}
                          size="small"
                          variant="contained"
                          onClick={() => { closeEdition() }}>
                          Cancelar
                        </Button>
                      </Grid>
                    </Grid>
                  </Box>

                </form>
              )}
            </Formik>
          </Box>

        </DialogContent>

      </Dialog>

    </Fragment>
  );
};

export default Panel;
